import React from 'react';
import { Tag } from 'antd';

const YesOrNo = ({bool, yesText = "是", noText = "否"}) => (
  bool ? <Tag color="green">{yesText}</Tag> : <Tag color="red">{noText}</Tag>
);

export default YesOrNo;
